export enum TipoUsuarioEnum {
  FORNECEDOR = 'F',
  GOVERNO = 'G',
  SOLICITANTE = 'S',
}
